import React, { createContext, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";

const AuthContext = createContext();
const { Provider } = AuthContext;

const authAxios = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

const AuthProvider = ({ children }) => {
  const history = useHistory();

  authAxios.interceptors.request.use(
    (config) => {
      if (localStorage.getItem("token")) {
        config.headers.Authorization = `Bearer ${localStorage.getItem(
          "token"
        )}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  const [authState, setAuthState] = useState({
    userInfo: null,
    isAuthenticated: false,
  });

  useEffect(() => {
    const getUserInfo = async () => {
      try {
        const { data } = await authAxios.get("/user-info");
        setAuthState({
          userInfo: data,
          isAuthenticated: true,
        });
      } catch (err) {
        setAuthState({
          userInfo: {},
          isAuthenticated: false,
        });
      }
    };

    getUserInfo();
  }, []);

  const setAuthInfo = ({ token, userInfo }) => {
    localStorage.setItem("token", token);
    setAuthState({
      userInfo,
      isAuthenticated: !!(userInfo && userInfo.id),
    });
  };

  const logout = async () => {
    try {
      await authAxios.post("/logout");
      localStorage.removeItem("token");
      setAuthState({
        userInfo: {},
        isAuthenticated: false,
      });
      history.push("/login");
    } catch (err) {
      console.log(err);
    }
  };

  const getAccessToken = () => localStorage.getItem("token");

  return (
    <Provider
      value={{
        authState,
        setAuthState: (authInfo) => setAuthInfo(authInfo),
        logout,
        getAccessToken,
      }}
    >
      {children}
    </Provider>
  );
};

export { AuthContext, AuthProvider };
